import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import Stream from 'flarum/common/utils/Stream';
import ShareContactModal from './components/ShareContactModal';
import validatePhone from './utils/validatePhone';

app.initializers.add('gcs-share-contact', () => {
  // Add a visible "Deel je contactgegevens" button on other users' profile cards
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;

    if (!app.session.user || app.session.user.id() === user.id()) return;

    items.add(
      'shareContact',
      <Button
        className="Button Button--primary GcsShareContact-btn"
        icon="fas fa-address-card"
        onclick={() => app.modal.show(ShareContactModal, { recipient: user })}
      >
        {app.translator.trans('gcs-share-contact.forum.share_button')}
      </Button>,
      -100
    );
  });

  // Initialise per-settings-page state
  extend(SettingsPage.prototype, 'oninit', function () {
    this.phoneNumber = Stream(app.session.user.attribute('phoneNumber') || '');
    this.phoneNumberSaving = false;
    this.phoneNumberError = '';
    this.allowShareContactLoading = false;
  });

  // Phone number field in Account section — stacked layout with inline validation
  extend(SettingsPage.prototype, 'accountItems', function (items) {
    const isInvalid = !validatePhone(this.phoneNumber());

    items.add(
      'phoneNumber',
      <div className="Form-group GcsPhoneField">
        <label>{app.translator.trans('gcs-share-contact.forum.settings.phone_label')}</label>
        <input
          className={'FormControl' + (this.phoneNumberError ? ' GcsInput--error' : '')}
          type="tel"
          value={this.phoneNumber()}
          oninput={(e) => {
            this.phoneNumber(e.target.value);
            this.phoneNumberError = validatePhone(e.target.value)
              ? ''
              : app.translator.trans('gcs-share-contact.forum.settings.phone_invalid');
          }}
          placeholder={app.translator.trans('gcs-share-contact.forum.settings.phone_placeholder')}
        />
        {this.phoneNumberError && (
          <p className="GcsShareContact-error">{this.phoneNumberError}</p>
        )}
        <Button
          className="Button Button--primary GcsPhoneField-save"
          loading={this.phoneNumberSaving}
          disabled={isInvalid}
          onclick={() => {
            if (isInvalid) return;
            this.phoneNumberSaving = true;
            app.session.user
              .save({ phoneNumber: this.phoneNumber() })
              .then(() => {
                this.phoneNumberSaving = false;
                m.redraw();
              })
              .catch(() => {
                this.phoneNumberSaving = false;
                m.redraw();
              });
          }}
        >
          {app.translator.trans('gcs-share-contact.forum.settings.save_button')}
        </Button>
      </div>
    );
  });

  // Opt-out toggle in Privacy section
  extend(SettingsPage.prototype, 'privacyItems', function (items) {
    items.add(
      'allowShareContact',
      <Switch
        state={app.session.user.preferences()?.allowShareContact ?? true}
        loading={this.allowShareContactLoading}
        onchange={(value) => {
          this.allowShareContactLoading = true;
          app.session.user
            .savePreferences({ allowShareContact: value })
            .then(() => {
              this.allowShareContactLoading = false;
              m.redraw();
            });
        }}
      >
        {app.translator.trans('gcs-share-contact.forum.settings.allow_share_label')}
      </Switch>
    );
  });
});
